export default __webpack_public_path__ + "static/media/volume_cover.0eb2736a.png";